import { useMemo, useState } from 'react';
import { Check, ChevronDown, ChevronRight, Search, X } from 'lucide-react';
import {
  Drawer, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle,
} from '@/components/ui/drawer';
import { kelimeleriIceriyor } from '@/lib/arama';

// İlave işin iş grubu (masraf grubu) seçici (kullanıcı, 2026-11-03).
//
// Ağacın üç kademesi (Ana Grup › Alt Grup › Masraf Grubu) tek tek SEÇİLMEZ:
// yalnız masraf grubu seçilir, üstleri ondan çıkar. Panelde:
// - "Sizin iş gruplarınız": alt yüklenicinin pozlarının grupları (`kendi`)
//   — ilave işin çoğu aynı işkolundan, çoğunlukla tek dokunuş yeter
// - arama her kademede: "boya" İnce İnşaat › Boya İşleri altını getirir
// - aramadan gezme: ana grup → alt grup → masraf grubu (en çok 3 dokunuş)
// Alt yüklenici formunda KOD GÖSTERİLMEZ; ofis ekranı `kodlu` ile açar.
// Saf props bileşeni — girişsiz form `lib/api.js`'i import etmeden kullanır.

const AZAMI_SONUC = 60;

const grupla = (liste, alan) => {
  const sirali = [];
  liste.forEach((g) => {
    let x = sirali.find((s) => s.ad === g[alan]);
    if (!x) { x = { ad: g[alan], ogeler: [] }; sirali.push(x); }
    x.ogeler.push(g);
  });
  return sirali;
};

function GrupSatiri({ g, secili, onSec, yolGoster, kodlu }) {
  return (
    <button type="button" onClick={onSec} aria-pressed={secili} data-testid={`masraf-secenek-${g.id}`}
      className={`w-full text-left rounded-xl border bg-white px-3 py-2.5 min-h-12 flex items-center gap-2
        active:bg-[#f5f0e8] ${secili ? 'border-[#2e2d29] ring-2 ring-[#2e2d29]/15' : 'border-[#d0c4b0]'}`}>
      <span className="min-w-0 flex-1">
        {yolGoster && <span className="block text-xs text-[#8a7e70] break-words">{g.ana_ad} › {g.alt_ad}</span>}
        <span className="block text-base leading-snug text-[#1a1916] font-medium break-words">
          {kodlu && g.kod && <span className="font-mono text-sm text-[#5c554b] mr-1.5">{g.kod}</span>}
          {g.ad}
        </span>
      </span>
      <span className={`h-6 w-6 shrink-0 rounded-full flex items-center justify-center
        ${secili ? 'bg-[#2e2d29] text-white' : 'border border-[#d0c4b0]'}`} aria-hidden="true">
        {secili && <Check size={14} />}
      </span>
    </button>
  );
}

function Acilir({ baslik, sayi, acik, onToggle, children, kucuk }) {
  return (
    <div className={kucuk ? '' : 'rounded-xl border border-[#d0c4b0] bg-white'}>
      <button type="button" onClick={onToggle} aria-expanded={acik}
        className={`w-full min-h-12 flex items-center gap-2 text-left px-3 ${kucuk ? 'py-2' : 'py-3'} active:bg-[#f5f0e8] rounded-xl`}>
        {acik ? <ChevronDown size={18} className="shrink-0 text-[#5c554b]" /> : <ChevronRight size={18} className="shrink-0 text-[#5c554b]" />}
        <span className={`flex-1 min-w-0 break-words ${kucuk ? 'text-sm font-medium text-[#3F3E39]' : 'text-base font-semibold text-[#1a1916]'}`}>{baslik}</span>
        <span className="text-xs text-[#8a7e70] tabular-nums">{sayi}</span>
      </button>
      {acik && <div className={kucuk ? 'pl-7 pr-1 pb-2 space-y-2' : 'px-3 pb-3 space-y-1'}>{children}</div>}
    </div>
  );
}

export default function MasrafGrubuSecici({ gruplar = [], value, onChange, disabled, kodlu = false, hatali, testId, baslik, kompakt = false }) {
  const [acik, setAcik] = useState(false);
  const [sorgu, setSorgu] = useState('');
  const [acikAna, setAcikAna] = useState(null);
  const [acikAlt, setAcikAlt] = useState(null);

  const secili = gruplar.find((g) => g.id === value);
  const kendi = useMemo(() => gruplar.filter((g) => g.kendi), [gruplar]);
  const bulunan = useMemo(() => (sorgu.trim()
    ? gruplar.filter((g) => kelimeleriIceriyor(sorgu, `${g.kod || ''} ${g.ana_ad} ${g.alt_ad} ${g.ad}`)).slice(0, AZAMI_SONUC)
    : []), [gruplar, sorgu]);
  const agac = useMemo(() => grupla(gruplar, 'ana_ad').map((a) => ({ ...a, altlar: grupla(a.ogeler, 'alt_ad') })), [gruplar]);

  const ac = () => {
    if (disabled) return;
    setSorgu('');
    // Seçili grup varsa ağaçta onun dalı açık gelir
    setAcikAna(secili?.ana_ad || null);
    setAcikAlt(secili ? `${secili.ana_ad}|${secili.alt_ad}` : null);
    setAcik(true);
  };
  const sec = (id) => { onChange(id); setAcik(false); };

  return (
    <>
      <button type="button" onClick={ac} disabled={disabled} data-testid={testId} aria-haspopup="dialog"
        title={kompakt && secili ? `${secili.ana_ad} › ${secili.alt_ad} › ${secili.ad}` : undefined}
        className={`w-full rounded-lg border bg-white text-left flex items-start gap-2
          disabled:opacity-60 active:bg-[#faf7f2] hover:bg-[#faf7f2] transition-colors
          ${kompakt ? 'min-h-9 px-2.5 py-1.5' : 'min-h-12 px-3 py-2.5'} ${hatali ? 'border-[#b4442f]' : 'border-[#d0c4b0]'}`}>
        {secili && kompakt ? (
          <span className="min-w-0 flex-1 text-sm leading-snug text-[#1a1916] break-words">
            <span className="text-xs text-[#8a7e70]">Grup: </span>{secili.ad}
          </span>
        ) : secili ? (
          <span className="min-w-0 flex-1">
            <span className="block text-xs text-[#8a7e70] break-words">{secili.ana_ad} › {secili.alt_ad}</span>
            <span className="block text-base leading-snug text-[#1a1916] font-medium break-words">
              {kodlu && secili.kod && <span className="font-mono text-sm text-[#5c554b] mr-1.5">{secili.kod}</span>}
              {secili.ad}
            </span>
          </span>
        ) : (
          <span className={`min-w-0 flex-1 flex items-center gap-2 text-[#8a7e70] ${kompakt ? 'min-h-5 text-sm' : 'min-h-7 text-base'}`}>
            <Search size={kompakt ? 14 : 16} className="shrink-0" /> İş grubunu seçin
          </span>
        )}
        <span className={`shrink-0 flex items-center gap-1 text-sm font-medium text-[#5c554b] ${kompakt ? 'min-h-5' : 'min-h-7'}`}>
          {secili && !kompakt ? 'Değiştir' : ''}<ChevronDown size={16} />
        </span>
      </button>

      <Drawer open={acik} onOpenChange={setAcik} shouldScaleBackground={false}>
        <DrawerContent className="mx-auto w-full max-w-lg lg:max-w-2xl h-[90dvh] bg-[#faf7f2] border-[#d0c4b0]" data-testid="masraf-paneli">
          <DrawerHeader className="text-left pb-2">
            <DrawerTitle className="text-[#1a1916]">{baslik || 'İş grubunu seçin'}</DrawerTitle>
            <DrawerDescription className="text-[#5c554b]">
              Yapılan işin hangi gruba girdiğini seçin. Emin değilseniz en yakın grubu seçin, ofis kontrol eder.
            </DrawerDescription>
            <div className="relative mt-2">
              <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8a7e70]" />
              <input type="text" value={sorgu} onChange={(e) => setSorgu(e.target.value)} enterKeyHint="search"
                placeholder="Ara: boya, sıva, sıhhi tesisat…" aria-label="İş grubu ara" data-testid="masraf-ara"
                className="w-full h-12 rounded-lg border border-[#d0c4b0] bg-white pl-10 pr-11 text-base text-[#1a1916]
                  placeholder:text-[#8a7e70] focus:outline-none focus:ring-2 focus:ring-[#2e2d29]/25" />
              {sorgu && (
                <button type="button" onClick={() => setSorgu('')} aria-label="Aramayı temizle"
                  className="absolute right-0.5 top-1/2 -translate-y-1/2 h-11 w-11 flex items-center justify-center text-[#8a7e70]">
                  <X size={18} />
                </button>
              )}
            </div>
          </DrawerHeader>

          <div className="flex-1 overflow-y-auto overscroll-contain px-4 pb-[max(1rem,env(safe-area-inset-bottom))] space-y-5">
            {sorgu.trim() ? (
              <section className="space-y-2">
                {bulunan.length === 0 && (
                  <p className="py-8 text-center text-sm text-[#5c554b]">Bu aramayla grup bulunamadı. Başka bir kelime deneyin.</p>
                )}
                {bulunan.map((g) => (
                  <GrupSatiri key={g.id} g={g} secili={g.id === value} onSec={() => sec(g.id)} yolGoster kodlu={kodlu} />
                ))}
              </section>
            ) : (
              <>
                {kendi.length > 0 && (
                  <section className="space-y-2">
                    <h3 className="text-xs font-semibold uppercase tracking-wide text-[#8a7e70]">
                      {kodlu ? 'Alt yüklenicinin iş grupları' : 'Sizin iş gruplarınız'}
                    </h3>
                    {kendi.map((g) => (
                      <GrupSatiri key={g.id} g={g} secili={g.id === value} onSec={() => sec(g.id)} yolGoster kodlu={kodlu} />
                    ))}
                  </section>
                )}
                <section className="space-y-2">
                  <h3 className="text-xs font-semibold uppercase tracking-wide text-[#8a7e70]">Tüm gruplar</h3>
                  {agac.map((a) => (
                    <Acilir key={a.ad} baslik={a.ad} sayi={a.ogeler.length} acik={acikAna === a.ad}
                      onToggle={() => { setAcikAna(acikAna === a.ad ? null : a.ad); setAcikAlt(null); }}>
                      {a.altlar.map((l) => {
                        const anahtar = `${a.ad}|${l.ad}`;
                        return (
                          <Acilir key={anahtar} kucuk baslik={l.ad} sayi={l.ogeler.length} acik={acikAlt === anahtar}
                            onToggle={() => setAcikAlt(acikAlt === anahtar ? null : anahtar)}>
                            {l.ogeler.map((g) => (
                              <GrupSatiri key={g.id} g={g} secili={g.id === value} onSec={() => sec(g.id)} kodlu={kodlu} />
                            ))}
                          </Acilir>
                        );
                      })}
                    </Acilir>
                  ))}
                </section>
              </>
            )}
          </div>
        </DrawerContent>
      </Drawer>
    </>
  );
}
